// extracted by mini-css-extract-plugin
export var bubble = "_3x-0";
export var container = "_3x-f";
export var contrastBorder = "_3x-g";
export var greyOut = "_3x-2";
export var initialsColor0 = "_3x-3";
export var initialsColor1 = "_3x-4";
export var initialsColor10 = "_3x-d";
export var initialsColor11 = "_3x-e";
export var initialsColor2 = "_3x-5";
export var initialsColor3 = "_3x-6";
export var initialsColor4 = "_3x-7";
export var initialsColor5 = "_3x-8";
export var initialsColor6 = "_3x-9";
export var initialsColor7 = "_3x-a";
export var initialsColor8 = "_3x-b";
export var initialsColor9 = "_3x-c";
export var initialsWrapper = "_3x-1";
export var large = "_3x-l";
export var medium = "_3x-k";
export var mediumSmall = "_3x-j";
export var mediumSmallMedium = "_3x-o";
export var micro = "_3x-h";
export var small = "_3x-i";
export var tiny = "_3x-n";
export var xTiny = "_3x-m";